/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';


import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useParams, useNavigate, generatePath } from 'react-router-dom';
import ReactMarkdown from "react-markdown";
import "../assets/css/story.css";

/*--logo--*/
import logo from '../assets/img/logo.webp';


/*========================================
        Functions!!!
=========================================*/

function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}


/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloadDocument={true}>
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloadDocument = {true}>
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}


/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer() {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img src={mu6} alt="Cow" loading="lazy" />
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img src={mu4} alt="Cow" loading="lazy" />
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img src={mu3} alt="Cow" loading="lazy" />
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img src={mu2} alt="Cow" loading="lazy" />
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img src={mu5} alt="Cow" loading="lazy" />
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img src={mu1} alt="Cow" loading="lazy" />
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}


/*=======================================================
    ! Story Content
=======================================================*/

function Marks() {
    let { id } = useParams();
    const [markdown, setMarkdown] = useState(null);

  if (id > 6 || id < 1 || isNaN(id) === true) {
    id = 404;
  }

    useEffect(() => {
    fetch(`/assets/posts/post${id}.md`)
      .then((res) => res.text())
      .then((text) => setMarkdown(text));
    }, [id]);

    return (
        <>
            <ReactMarkdown>{markdown}</ReactMarkdown>
        </>
    );
}

/* shuffle random number from list  */

const RandNumb = () => {
    const { id } = useParams();
    const array = [1, 2, 3, 4, 5, 6].filter(n => n !== Number(id));
    const shuffled = array.sort(() => 0.5 - Math.random());
    return {
        liczba1: shuffled[0],
        liczba2: shuffled[1],
    };
};

const Connect = ({ numer1, numer2 }) => {
    const [short, setShort] = useState(null);
    const [short2, setShort2] = useState(null);
    let navigate = useNavigate({ replace: true })
  
    const route = () => {
      // location.reload(true);
      console.log(`navigate - ${numer1}`);
      window.scrollTo(0, 0);
      navigate(generatePath("/story/:id", { id: numer1 }));
    }

  const route2 = () => {
      console.log(`navigate - ${numer2}`);
      window.scrollTo(0, 0);
      navigate(generatePath("/story/:id", { id: numer2 }));
      // location.reload(true);
    }

    useEffect(() => {
        fetch(`/assets/shorts/short${numer1}.md`)
            .then((res) => res.text())
            .then((text) => setShort(text));
    },);

    useEffect(() => {
        fetch(`/assets/shorts/short${numer2}.md`)
            .then((res) => res.text())
            .then((text) => setShort2(text));
    },);

    function ClickedBut() {
        return (
          <>
            <Row className='title'>
                <Col>
                    <h2>Zobacz też!</h2>
                </Col> 
            </Row>
            <Row className='shorts'>
                <Col lg={6} md={6} sm={12} className='short'>
                  <button onClick={route}>
                    <ReactMarkdown>{short}</ReactMarkdown>
                  </button>
                </Col>
                <Col lg={6} md={6} sm={12} className='short'>
                  <button onClick={route2}>
                    <ReactMarkdown>{short2}</ReactMarkdown>
                  </button>
                </Col>
            </Row>
          </>
        );
    }
  
  return (
    <ClickedBut />
  );

};

function Short() {
  const { liczba1, liczba2 } = RandNumb();

  return (
    <>
      <Connect numer1={liczba1} numer2={liczba2} />
    </>
  );
}

function Story() {
    return (
        <>
            <Header />
            <article className='Contener'>
                <article className='Story'>
                <section className='markdowns'>
                    <Marks />
                </section>
                <section className='shorts'>
                    <Short />
                </section>
                </article>
            </article>
            <Footer />
        </>
    );
}

export default Story;